import type { MD3Theme } from 'react-native-paper'

export interface SemanticColors {
    success: string
    successLight: string
    successBorder: string
    error: string
    errorLight: string
    errorBorder: string
    warning: string
    info: string
    neutral: string

    successText: string
    errorText: string

    infoLight: string
    infoBorder: string
    infoText: string

    successIcon: string

    helpText: string

    statusActive: string
    statusPending: string
    statusApproved: string
    statusRejected: string

    mutedText: string
    divider: string
}

const LIGHT_COLORS: SemanticColors = {
    success: '#059669',
    successLight: '#f0fdf4',
    successBorder: '#86efac',
    successText: '#059669',

    error: '#dc2626',
    errorLight: '#fef2f2',
    errorBorder: '#fca5a5',
    errorText: '#dc2626',

    warning: '#f59e0b',

    info: '#2563eb',
    infoLight: '#e3f2fd',
    infoBorder: '#2196f3',
    infoText: '#1976d2',

    neutral: '#64748b',

    successIcon: '#4caf50',

    helpText: '#757575',

    statusActive: '#16a34a',
    statusPending: '#2563eb',
    statusApproved: '#059669',
    statusRejected: '#dc2626',

    mutedText: '#6b7280',
    divider: '#e5e7eb',
}

const DARK_COLORS: SemanticColors = {
    success: '#10b981',
    successLight: '#064e3b',
    successBorder: '#10b981',
    successText: '#10b981',

    error: '#ef4444',
    errorLight: '#7f1d1d',
    errorBorder: '#ef4444',
    errorText: '#ef4444',

    warning: '#fbbf24',

    info: '#3b82f6',
    infoLight: '#1e3a5f',
    infoBorder: '#3b82f6',
    infoText: '#60a5fa',

    neutral: '#94a3b8',

    successIcon: '#4ade80',

    helpText: '#9ca3af',

    statusActive: '#22c55e',
    statusPending: '#60a5fa',
    statusApproved: '#10b981',
    statusRejected: '#ef4444',

    mutedText: '#9ca3af',
    divider: '#374151',
}

export function getSemanticColors(theme: MD3Theme): SemanticColors {
    return theme.dark ? DARK_COLORS : LIGHT_COLORS
}

import { useTheme } from 'react-native-paper'

export function useSemanticColors(): SemanticColors {
    const theme = useTheme()
    return getSemanticColors(theme)
}
